'use client';

export const DocumentError = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M7.30484 30C6.67165 30 6.12921 29.7742 5.67753 29.3225C5.22584 28.8708 5 28.3284 5 27.6952V4.30484C5 3.67165 5.22584 3.12921 5.67753 2.67753C6.12921 2.22584 6.67165 2 7.30484 2H18.7893C19.1051 2 19.4054 2.06239 19.6901 2.18716C19.9745 2.31193 20.2224 2.47686 20.4339 2.68195L26.4233 8.67137C26.6284 8.88284 26.7933 9.13079 26.9181 9.41521C27.0429 9.69988 27.1053 10.0001 27.1053 10.316V27.6952C27.1053 28.3284 26.8794 28.8708 26.4277 29.3225C25.9761 29.7742 25.4336 30 24.8004 30H7.30484ZM18.8169 9.08105V3.85168H7.30484C7.19161 3.85168 7.08772 3.89884 6.99316 3.99316C6.89884 4.08772 6.85168 4.19161 6.85168 4.30484V27.6952C6.85168 27.8084 6.89884 27.9123 6.99316 28.0068C7.08772 28.1012 7.19161 28.1483 7.30484 28.1483H24.8004C24.9136 28.1483 25.0175 28.1012 25.1121 28.0068C25.2064 27.9123 25.2536 27.8084 25.2536 27.6952V10.2338H19.9693C19.6466 10.2338 19.3738 10.1225 19.1511 9.89968C18.9283 9.67667 18.8169 9.40379 18.8169 9.08105Z"
				fill="currentColor"
			/>
			<path
				d="M16.1307 21.4169C16.3908 21.4169 16.612 21.3254 16.7942 21.1424C16.9767 20.9596 17.0679 20.7327 17.0679 20.4615V13.6148C17.0679 13.3596 16.9765 13.1406 16.7935 12.9579C16.6105 12.7754 16.3888 12.6842 16.1285 12.6842C15.8684 12.6842 15.6456 12.7754 15.4602 12.9579C15.275 13.1406 15.1824 13.3596 15.1824 13.6148V20.4615C15.1824 20.7327 15.2753 20.9596 15.4613 21.1424C15.6472 21.3254 15.8703 21.4169 16.1307 21.4169Z"
				fill="currentColor"
			/>
			<path
				d="M16.1001 25.2105C16.4241 25.2105 16.6926 25.1065 16.9058 24.8984C17.119 24.6904 17.2256 24.4219 17.2256 24.0931C17.2256 23.7642 17.1209 23.4973 16.9114 23.2925C16.7019 23.0874 16.4316 22.9849 16.1005 22.9849C15.7763 22.9849 15.5119 23.0874 15.3073 23.2925C15.1024 23.4973 15 23.7642 15 24.0931C15 24.4219 15.1023 24.6904 15.3069 24.8984C15.5117 25.1065 15.7761 25.2105 16.1001 25.2105Z"
				fill="currentColor"
			/>
		</svg>
	);
};
